
function innerBannerWrapper() {
  return (
    <>
      <section className="innerBannerWrapper">
        <img src="assets/images/product-close-banner.webp" alt="" />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="txt-white titleMain text-center">
                WALTZ DOOR & PARTITION SYSTEMS
              </h2>
              <p className="txt-white text-center">
                <b>Open the doors to a world of understated sophistication.</b>{" "}
                Sliding, pivoted or gliding, each door is engineered to
                perfection along-with a soft touch mechanism for smooth and easy
                operation. Discover the perfect frame to your dream space.
              </p>
            </div>
          </div>
        </div>
      </section>


    </>
  );
}

export default innerBannerWrapper;
